<button
  pButton
  pRipple
  icon="pi pi-arrow-left"
  type="button"
  label="Close"
  class="p-button-text text-white close-button"
  (click)="close()"
></button>
